<div mat-dialog-content class="centerContents">
  <p class="mat-dialog-title-font">{{subscriptionDialogTitle}}</p>
  <form [formGroup]="subscriptionForm" novalidate>
    <p>
      <mat-form-field appearance="fill" [style.width.%]="100">
        <input matInput [(ngModel)]="inputData['email']" placeholder="Enter email" formControlName="subscriberEmail" id="subscriberEmail">
        <mat-hint align="end">Enter a valid email address.</mat-hint>
        @if (displayError('subscriberEmail', 'required')) {
          <mat-error>
            Email is required
          </mat-error>
        }
        @if (displayError('subscriberEmail', 'email')) {
          <mat-error>
            Please enter a valid email
          </mat-error>
        }
      </mat-form-field>
    </p>
  </form>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancelDialog('form')">Cancel</button>
    <button mat-button (click)="onRegister()" cdkFocusInitial>Register</button>
  </div>
</div>

